import React, { useState, useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import useNetwork from '../useNetwork';
import useInfiniteScroll from "../useInfiniteScroll";
import { AppDataContext, VLink } from "./AppDataContext"
import { Loader } from './Loader';
import CurrencyFormat from 'react-currency-format';
import { Helmet } from "react-helmet";


export function Search(props) {
	const context = useContext(AppDataContext);
	const { loading, networkError, netRequest, netRenderError } = useNetwork(true);

	const startIx = useRef(0);
	const totalCount = useRef(null);
	const pageSize = 25;	 

	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(startSearch);

	const [searchText, setSearchText] = useState(null);
	const [lots, setLots] = useState(null);
	const [total, setTotal] = useState(null);
	const [categories, setCategories] = useState(null);
	const [showClosed, setShowClosed] = useState(props.location.state?.showClosed ?? false);
	const [selectedCategories, setSelectedCategories] = useState(props.location.state?.selectedCategories ?? []);
	const [endReached, setEndReached] = useState(false);

	const searchLots = (startAt, text, closed, categories) => {

		const search = async (startingAt, search, closed, categories) => {
			const url = 'api/site/search/';
			console.log(url);
			const postData = {
				Search: search,
				Closed: closed,
				Categories: categories,
				OrderBy: '',
				Skip: startingAt,
				Take: pageSize
			};
			const response = await netRequest(url,postData);

			if (response.data != null) {
				setTotal(response.data.totalLots);

				if (startingAt == 0)
					setLots(response.data.lots);
				else
					setLots([...lots, ...response.data.lots]);			 

				totalCount.current = response.data.totalLots;
				startIx.current = startingAt + pageSize;
				const endReached = startIx.current >= response.data.totalLots;
				setIsDone(endReached);

			}
			setIsFetching(false);

		};

		if(text!=null && text != '' && (totalCount.current == null || startIx.current < totalCount.current))
			search(startAt, text, closed, categories);

	}
	const history = useHistory();


	const searchByTab = (showClosed) =>
	{
		setShowClosed(showClosed);
		history.replace('/search', { searchText: searchText, showClosed: showClosed, selectedCategories: selectedCategories });
	}

	const handleCategoryChange = (e) => {
		let value = e.target.value;
		let cats = [];
		if (e.target.checked) {
			cats = [...selectedCategories, value];
			setSelectedCategories(cats);
		} else {
			cats = [...selectedCategories];
			const index = cats.indexOf(value);
			if (index !== -1) {
				cats.splice(index, 1);
				setSelectedCategories(cats);
			}
		}
		history.replace('/search', { searchText: searchText, showClosed: showClosed, selectedCategories: cats });

	}
	function startSearch(fromBeginning) {
		if (props.location.state?.searchText && props.location.state.searchText != '') {
			setSearchText(props.location.state.searchText);
			console.log('searching ' + props.location.state.searchText);

			const startingAt = fromBeginning  ? 0 : startIx.current;

			searchLots(startingAt, props.location.state.searchText, showClosed, selectedCategories);
		}
	}

	useEffect(() => {
		startIx.current = 0;
		totalCount.current = null;
		startSearch(true)
	}, [props.location.state?.searchText, showClosed, selectedCategories]);

	useEffect(() => {
		const fetchCats = async () => {
			const url = 'api/site/getcategories/';
			const response = await netRequest(url);

			if (response.data != null) {
				setCategories(response.data);

				// check categories
				//if (props.location.state?.selectedCategories) {
				//	setSelectedCategories(props.location.state?.selectedCategories);
				//} else {
				//	setSelectedCategories([]);

				//}
			}
		}
		fetchCats();

	}, []);

 
  

    return (
		<main>
			<Helmet>
				<title>Search</title>
			</Helmet>
			<section class="p-3 p-md-5">
				<div class="container">
					<div class="row">
						<div class="col-12 mb-3">
							<div class="row">
								<div class="p-3 background-white search-summary">
									<div class="search-summary__phrase">
										<h1 class="text-left">{searchText ? "Searching for " + searchText : "Search"}</h1> {searchText && <span class="results">({total} Results)</span>}
									</div>
								{/*	<div class="search-summary__buttons mt-3">*/}
								{/*		<button class="btn btn-secondary   mb-3 me-3" title="Favorites">*/}
								{/*			 <i class="bi bi-star-fill me-1"></i>Favorites</button>*/}
								{/*		<button class="btn btn-secondary mb-3 me-3" title="Today">Today</button>*/}
								{/*		<button class="btn btn-secondary mb-3 me-3" title="Tomorrow">Tomorrow</button>*/}
								{/*		<button class="btn btn-secondary mb-3 me-3" title="15 Days">15 Days</button>*/}
								{/*		<button class="btn btn-primary mb-3 me-3" title="Follow"><i class="bi bi-bell me-2"></i>Follow</button>*/}
								{/*		<a href="search-map.html" class="btn btn-primary mb-3 float-none float-md-end" title="View Map"><i class="bi bi-map me-2"></i>View Map</a>*/}
								{/*	</div>*/}
								</div>
							</div>
						</div>
						<div class="col-12 mb-3">
							<div class="row">
								<ul class="nav nav-tabs nav-justified p-0 sticky-top">
									<li class="nav-item background-white"  >
										<button className={"nav-link " + (showClosed == false ? 'active' : '')}  data-bs-toggle="tab"
											onClick={evt => searchByTab(false)} >Upcoming</button>
									</li>
									<li class="nav-item background-white"  >
										<button className={"nav-link " + (showClosed == true ? 'active' : '')} data-bs-toggle="tab"
											onClick={evt => searchByTab(true)} >Past</button>
									</li>
								</ul>
								<div class="col-12 col-md-3 search-filters">
									<div class="background-white py-3">
										<h3>Filters</h3>
										{/*<div class="input-group mb-3">*/}
										{/*	<label for="zipcode" class="form-label w-100">Zip Code</label>*/}
										{/*	<input type="text" class="form-control" id="zipcode" placeholder="Zip code" />*/}
										{/*</div>*/}
										{/*<div class="input-group mb-3">*/}
										{/*	<label for="zipcode" class="form-label w-100">Distance</label>*/}
										{/*	<p id="customRangeValue" class="range-value mb-0 mx-auto text-center">Select Value</p>*/}
                                        {/*	<input type="range" class="form-range" min="1" max="50" id="customRange" onchange="updateRangeValue();" />*/}

                                        {/*</div>*/}


                                        <div class="input-group">
                                            <label for="label" class="form-label w-100">Category</label>
                                            {categories && categories.length > 0 ?
												categories.map(cat =>
												(
                                                    <div class="form-check mb-3">
														<input key={"cat-" + cat.value} class="form-check-input" type="checkbox" value={cat.value} id={"cat-" + cat.value}
															onChange={e => handleCategoryChange(e)}
															checked={selectedCategories?.includes(cat.value)}														/>
														<label class="form-check-label" for={"cat-" + cat.value}>
															{cat.name}
                                                        </label>
                                                    </div>
												)
												)
												: <></>
											}
                                        </div>

                                    </div>
                                </div>
								<div class="col-12 col-md-9">

 									<div class="tab-content">
										<div class="tab-pane container h-100 py-3 px-0 active">
											<div class="row">
												<div class="col-12 mb-1">
													<div class="table-responsive">
														<table class="table table-striped align-middle table-borderless">
															<thead>
																<tr>
																	<th scope="col"></th>
																	<th scope="col">Title</th>
																	<th scope="col">Auction</th>
																	<th scope="col" class="text-center">Price</th>
																	<th scope="col" class="text-end">Ending</th>
																</tr>
															</thead>
															<tbody>
																{lots && lots.length > 0 ?
																	lots.map(lot => (
																	<tr>
																		<td>
																			{lot.imageSecureId &&
																				<img src={"/api/site/inventoryimage/" + lot.imageSecureId + "/30"} title={lot.title} alt={lot.title} />
																			}
																		</td>
																			
																			<td>
																				<VLink to={"/auction/" + lot.auctionSessionSecureId + "/lot/" + lot.secureId}
																						title={lot.title} className="text-uppercase">
																					{lot.title}
																				</VLink>
																			</td>
																				<td>
																					<VLink to={"/auction/" + lot.auctionSessionSecureId}
																						title={lot.auctionTitle} className="text-uppercase">
																						{lot.auctionTitle}
																					</VLink>
																				</td>
																			<td class="text-end">
																				{showClosed && !context.isLoggedIn ?
																					<span>Log in to see</span>
																					:
																					<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={lot.currentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
																				}
																			</td>
																			<td class="text-end">
																					{lot.closeTimeLocalStr }
																			</td>
																		</tr>

																	)) :
																	<tr>
																		<td></td>
																		<td></td>
																		<td></td>
																		<td></td>
																		<td></td>
																	</tr>
																	}
															</tbody>
													</table>
														 
													 
													</div>

												</div>
													<div class="col-12 mb-3 text-end">
														{(!isFetching && total > 0 && !isDone) &&
															<button onClick={evt => startSearch(false)} class="btn btn-secondary" title="Show More...">
																Show More <i class="bi bi-arrow-right-short"></i>
															</button>
														}
													</div>
												
											 

											</div>
										</div>
									 
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</section>
			<Loader loading={loading} />

 		</main>
		                                     

    );

}